export default __webpack_public_path__ + "static/rovo-actions-light-17a33db8ab91a4f94b0070eca035280b01aaefbe124afe84a2c159f383dbc01f.png";